export const minutesOfMeetingForm: any = {
    meetingName:"",
    meetingOwner:{},
    meetingDateForm :"",
    meetingDateTo:"",
    attendees:[],
    excuses:[],
    description:"",
    npdIds:[],
    npdIdData:[],
    discussionItems:[],
    momId:"",
    attachments:[],
    presentDpt:[],
    absentDpt:[]
  };